import type { ParentsBulkImportJob } from '~entities/parent/api/get-parents-bulk-import-status';

/** Live counter: current parent index while in-flight, else completed count. */
export function getParentsBulkImportActiveIndex(
  job: Pick<
    ParentsBulkImportJob,
    'status' | 'processedRecords' | 'currentParentIndex'
  > | null | undefined,
): number {
  if (!job) return 0;
  const completed = job.processedRecords ?? 0;
  const current = job.currentParentIndex ?? 0;
  if (
    job.status === 'processing' &&
    current > 0 &&
    current > completed
  ) {
    return current;
  }
  return completed;
}

export function isParentsBulkImportParentInFlight(
  job: Pick<
    ParentsBulkImportJob,
    'status' | 'processedRecords' | 'currentParentIndex'
  > | null | undefined,
): boolean {
  if (!job || job.status !== 'processing') return false;
  const completed = job.processedRecords ?? 0;
  const current = job.currentParentIndex ?? 0;
  return current > 0 && current > completed;
}
